<template>
  <div>
    <template v-if="status">
      <vs-chip
        :color="corStatus(status.slug)"
        class="inline-flex float-none main-menu-sidebar"
      >{{ status.nome }}</vs-chip>
      <div v-if="statusMotivo">
        <small class="product-category font-medium">{{ statusMotivo.nome }}</small>
      </div>
    </template>
  </div>
</template>

<script>
import {
  STATUS_DIGITANDO,
  STATUS_EM_ANALISE,
  STATUS_PENDENTES,
  STATUS_ATIVOS,
  STATUS_REVISAO,
  STATUS_CANCELADOS
} from "@constants/index";

export default {
  name: "status-contrato",
  props: ["status", "statusMotivo"],
  methods: {
    corStatus(slug) {
      switch (slug) {
        case STATUS_DIGITANDO:
          return null;
        case STATUS_EM_ANALISE:
          return "warning";
        case STATUS_ATIVOS:
          return "success";
        case STATUS_PENDENTES:
          return null;
        case STATUS_REVISAO:
          return "primary";
        case STATUS_CANCELADOS:
          return "danger";
        default:
          return "primary";
      }
    }
  }
};
</script>
